import { HttpErrorResponse } from "@angular/common/http";
import { AddLearnerDto } from "src/app/_models/AddLearnerDto";
import { Userprofile } from "src/app/_models/Userprofile";

export interface CreateLearnerState {
  loading: boolean;
  learner: AddLearnerDto;
  error: HttpErrorResponse;
  result: Userprofile;
}

export const initialCreateLearnerState: CreateLearnerState = {
  learner: null,
  loading: false,
  error: null,
  result: null
}